import React, { useState } from "react";
import { Smile, X } from "lucide-react";

const emojiCategories = [
  {
    name: "Smileys & People",
    emojis: ["😀", "😃", "😄", "😁", "😆", "😅", "😂", "🤣", "😊", "😇", "🙂", "🙃", "😉", "😌", "😍", "🥰", "😘", "😗", "😙", "😚", "😋", "😛", "😝", "😜", "🤪", "🤨", "🧐", "🤓", "😎", "🤩", "🥳", "😏", "😒", "😞", "😔", "😟", "😕", "🙁", "☹️", "😣", "😖", "😫", "😩", "🥺", "😢", "😭", "😤", "😠", "😡", "🤬", "🤯", "😳", "🥵", "🥶", "😱", "😨", "😰", "😥", "😓"]
  },
  {
    name: "Animals & Nature",
    emojis: ["🐶", "🐱", "🐭", "🐹", "🐰", "🦊", "🐻", "🐼", "🐨", "🐯", "🦁", "🐮", "🐷", "🐸", "🐵", "🙈", "🙉", "🙊", "🐒", "🦍", "🦧", "🐕", "🐩", "🦮", "🐕‍🦺", "🐈", "🐈‍⬛", "🦄", "🐎", "🦓", "🦌", "🐂", "🐃", "🐄", "🐪", "🐫", "🦙", "🦒", "🐘", "🦏", "🦛", "🐐", "🐑", "🐎", "🦓", "🦌", "🐂", "🐃", "🐄", "🐪", "🐫", "🦙", "🦒", "🐘", "🦏", "🦛", "🐐", "🐑", "🐎", "🦓", "🦌", "🐂", "🐃", "🐄", "🐪", "🐫", "🦙", "🦒", "🐘", "🦏", "🦛", "🐐", "🐑"]
  },
  {
    name: "Food & Drink",
    emojis: ["🍎", "🍊", "🍋", "🍌", "🍉", "🍇", "🍓", "🫐", "🍈", "🍒", "🍑", "🥭", "🍍", "🥥", "🥝", "🍅", "🍆", "🥑", "🥦", "🥬", "🥒", "🌶️", "🫑", "🌽", "🥕", "🫒", "🧄", "🧅", "🥔", "🍠", "🥐", "🥖", "🍞", "🥨", "🥯", "🧀", "🥚", "🍳", "🧈", "🥞", "🧇", "🥓", "🥩", "🍗", "🍖", "🦴", "🌭", "🍔", "🍟", "🍕", "🫓", "🥙", "🌮", "🌯", "🫔", "🥗", "🥘", "🫕", "🥫", "🍝", "🍜", "🍲", "🍛", "🍣", "🍱", "🥟", "🦪", "🍤", "🍙", "🍚", "🍘", "🍥", "🥠", "🥮", "🍢", "🍡", "🍧", "🍨", "🍦", "🥧", "🧁", "🍰", "🎂", "🍮", "🍭", "🍬", "🍫", "🍿", "🍩", "🍪", "🌰", "🥜", "🍯"]
  },
  {
    name: "Activities",
    emojis: ["⚽", "🏀", "🏈", "⚾", "🥎", "🎾", "🏐", "🏉", "🎱", "🪀", "🏓", "🏸", "🏒", "🏑", "🥍", "🏏", "🪃", "🥅", "⛳", "🪁", "🏹", "🎣", "🤿", "🥊", "🥋", "🎽", "🛹", "🛷", "⛸️", "🥌", "🎿", "⛷️", "🏂", "🪂", "🏋️‍♀️", "🏋️", "🏋️‍♂️", "🤼‍♀️", "🤼", "🤼‍♂️", "🤸‍♀️", "🤸", "🤸‍♂️", "⛹️‍♀️", "⛹️", "⛹️‍♂️", "🤺", "🤾‍♀️", "🤾", "🤾‍♂️", "🏌️‍♀️", "🏌️", "🏌️‍♂️", "🏇", "🧘‍♀️", "🧘", "🧘‍♂️", "🏄‍♀️", "🏄", "🏄‍♂️", "🏊‍♀️", "🏊", "🏊‍♂️", "🤽‍♀️", "🤽", "🤽‍♂️", "🚣‍♀️", "🚣", "🚣‍♂️", "🧗‍♀️", "🧗", "🧗‍♂️", "🚵‍♀️", "🚵", "🚵‍♂️", "🚴‍♀️", "🚴", "🚴‍♂️", "🏆", "🥇", "🥈", "🥉", "🏅", "🎖️", "🏵️", "🎗️", "🎫", "🎟️", "🎪", "🤹", "🤹‍♀️", "🤹‍♂️", "🎭", "🩰", "🎨", "🎬", "🎤", "🎧", "🎼", "🎵", "🎶", "🪘", "🥁", "🎷", "🎺", "🎸", "🪕", "🎻", "🎲", "♠️", "♥️", "♦️", "♣️", "♟️", "🃏", "🀄", "🎴", "🎯", "🎳", "🎮", "🕹️", "🎰", "🧩", "🪅", "🪆", "♠️", "♥️", "♦️", "♣️", "♟️", "🃏", "🀄", "🎴", "🎯", "🎳", "🎮", "🕹️", "🎰", "🧩", "🪅", "🪆"]
  },
  {
    name: "Travel & Places",
    emojis: ["🚗", "🚕", "🚙", "🚌", "🚎", "🏎️", "🚓", "🚑", "🚒", "🚐", "🛻", "🚚", "🚛", "🚜", "🏍️", "🛵", "🚲", "🛴", "🛹", "🛼", "🚁", "🛸", "✈️", "🛩️", "🛫", "🛬", "🪂", "💺", "🚀", "🛰️", "🚉", "🚞", "🚝", "🚄", "🚅", "🚈", "🚂", "🚆", "🚇", "🚊", "🚍", "🚘", "🚖", "🚡", "🚠", "🚟", "🎢", "🎡", "🎠", "⛵", "🛥️", "🚤", "⛴️", "🛳️", "🚢", "⚓", "🚧", "⛽", "🚨", "🚥", "🚦", "🛑", "🚏", "🗾", "🗺️", "🗿", "🗽", "🗼", "🏰", "🏯", "🏟️", "🎡", "🎢", "🎠", "⛲", "⛱️", "🏖️", "🏝️", "🏔️", "⛰️", "🌋", "🗻", "🏕️", "⛺", "🛖", "🏠", "🏡", "🏘️", "🏚️", "🏗️", "🏭", "🏢", "🏬", "🏣", "🏤", "🏥", "🏦", "🏨", "🏪", "🏫", "🏩", "💒", "🏛️", "⛪", "🕌", "🛕", "🕍", "🕋", "⛩️", "🛤️", "🛣️", "🗾", "🗺️", "🗿", "🗽", "🗼", "🏰", "🏯", "🏟️", "🎡", "🎢", "🎠", "⛲", "⛱️", "🏖️", "🏝️", "🏔️", "⛰️", "🌋", "🗻", "🏕️", "⛺", "🛖", "🏠", "🏡", "🏘️", "🏚️", "🏗️", "🏭", "🏢", "🏬", "🏣", "🏤", "🏥", "🏦", "🏨", "🏪", "🏫", "🏩", "💒", "🏛️", "⛪", "🕌", "🛕", "🕍", "🕋", "⛩️", "🛤️", "🛣️"]
  },
  {
    name: "Objects",
    emojis: ["⌚", "📱", "📲", "💻", "⌨️", "🖥️", "🖨️", "🖱️", "🖲️", "🕹️", "🗜️", "💽", "💾", "💿", "📀", "📼", "📷", "📸", "📹", "🎥", "📽️", "🎞️", "📞", "☎️", "📟", "📠", "📺", "📻", "🎙️", "🎚️", "🎛️", "🧭", "⏱️", "⏲️", "⏰", "🕰️", "⌛", "⏳", "📡", "🔋", "🔌", "💡", "🔦", "🕯️", "🪔", "🧯", "🛢️", "💸", "💵", "💴", "💶", "💷", "💰", "💳", "💎", "⚖️", "🧰", "🔧", "🔨", "⚒️", "🛠️", "⛏️", "🪓", "🪚", "🔩", "⚙️", "🪤", "🧱", "⛓️", "🧲", "🔫", "💣", "🧨", "🪓", "🔪", "🗡️", "⚔️", "🛡️", "🚬", "⚰️", "🪦", "⚱️", "🏺", "🔮", "📿", "🧿", "💈", "⚗️", "🔭", "🔬", "🕳️", "🩹", "🩺", "💊", "💉", "🩸", "🧬", "🦠", "🧫", "🧪", "🌡️", "🧹", "🧺", "🧻", "🚽", "🚰", "🚿", "🛁", "🛀", "🧴", "🧷", "🧸", "🧵", "🧶", "🪡", "🪢", "🪣", "🧽", "🧯", "🛒", "🛍️", "🛎️", "🪑", "🚪", "🪟", "🪞", "🪆", "🖼️", "🪞", "🪟", "🚪", "🪑", "🛎️", "🛍️", "🛒", "🧯", "🧽", "🪣", "🪢", "🪡", "🧶", "🧵", "🧸", "🧷", "🧴", "🛀", "🛁", "🚿", "🚰", "🚽", "🧻", "🧺", "🧹", "🌡️", "🧪", "🧫", "🦠", "🧬", "🩸", "💉", "💊", "🩺", "🩹", "🕳️", "🔬", "🔭", "⚗️", "💈", "🧿", "📿", "🔮", "🏺", "⚱️", "🪦", "⚰️", "🚬", "🛡️", "⚔️", "🗡️", "🔪", "🪓", "🧨", "💣", "🔫", "🧲", "⛓️", "🧱", "🪤", "⚙️", "🔩", "🪚", "🪓", "⛏️", "🛠️", "⚒️", "🔨", "🔧", "🧰", "⚖️", "💎", "💳", "💰", "💷", "💶", "💴", "💵", "💸", "🛢️", "🧯", "🪔", "🕯️", "🔦", "💡", "🔌", "🔋", "📡", "⏳", "⌛", "🕰️", "⏰", "⏲️", "⏱️", "🧭", "🎛️", "🎚️", "🎙️", "📻", "📺", "📠", "📟", "☎️", "📞", "🎞️", "📽️", "🎥", "📹", "📸", "📷", "📼", "📀", "💿", "💾", "💽", "🗜️", "🕹️", "🖲️", "🖱️", "🖨️", "🖥️", "⌨️", "💻", "📲", "📱", "⌚"]
  }
];

export default function EmojiPicker({ onEmojiSelect, isOpen, onClose }) {
  const [selectedCategory, setSelectedCategory] = useState(0);

  console.log("EmojiPicker rendered, isOpen:", isOpen);

  if (!isOpen) return null;

  return (
    <div className="emoji-picker">
      <div className="emoji-picker-header">
        <h3>Choose an emoji</h3>
        <button onClick={onClose} className="emoji-picker-close">
          <X size={20} />
        </button>
      </div>
      
      <div className="emoji-picker-categories">
        {emojiCategories.map((category, index) => (
          <button
            key={index}
            onClick={() => setSelectedCategory(index)}
            className={`emoji-category-btn ${selectedCategory === index ? 'active' : ''}`}
          >
            {category.name}
          </button>
        ))}
      </div>
      
      <div className="emoji-picker-content">
        <div className="emoji-grid">
          {emojiCategories[selectedCategory].emojis.map((emoji, index) => (
            <button
              key={index}
              onClick={() => {
                onEmojiSelect(emoji);
                onClose();
              }}
              className="emoji-btn"
            >
              {emoji}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
